<template>
    <div class="inside_pages_right">
        <div class="inside_pages_right_top">
           <div class="inside_header_title">晨午检</div>
        </div>
        <div class="inside_pages_right_content">
            <div class="inside_pages_right_content_top ">
                <div class="inside_pages_right_content_top_left">
                    &nbsp;&nbsp;
                    <el-button type="primary" plain size="mini"  icon="el-icon-download">下载模版</el-button>
                    <el-button type="primary" plain size="mini"  icon="el-icon-bottom-right">导入</el-button>
                    <el-button type="danger" plain size="mini"  icon="el-icon-top-right">导出学生健康登记表</el-button>
                </div>

                <div class="inside_pages_right_content_top_right">
                     <el-select v-model="requestData.classId" placeholder="请选择班级" size="mini">
                        <el-option  value="">全部</el-option>
                        <el-option v-for="(value,key) in classList " :key="key" :label="value.className"   :value="value.id">
                            {{value.className}}
                        </el-option>
                    </el-select>&nbsp;
                    <el-select v-model="requestData.status1" size="mini">
                        <el-option  label="身体状况" value="">
                        </el-option>
                        <el-option  label="良好" value="0">
                        </el-option>
                        <el-option  label="生病" value="1">
                        </el-option>
                    </el-select>&nbsp;
                    <el-select v-model="requestData.status2" size="mini">
                        <el-option  label="班级等级状态" value="">
                        </el-option>
                        <el-option  label="未登记" value="0">
                        </el-option>
                        <el-option  label="已登记" value="1">
                        </el-option>
                    </el-select>&nbsp;
                    <el-date-picker
                        size="mini"
                        v-model="requestData.date"
                        align="right"
                        type="date"
                        placeholder="时间筛选默认今天"
                        :picker-options="pickerOptions">
                    </el-date-picker>&nbsp;


                    <el-button size="mini" type="primary" plain icon="el-icon-search">搜索</el-button>
                </div>
            </div>
            <div class="inside_pages_right_content_center" >
                <el-table :data="responseData.list"  height="100%" border style="width: 100%">

                    <el-table-column prop="id" label="班级名称">
                    </el-table-column>

                    <el-table-column prop="name1" label="班级名称">
                    </el-table-column>

                    <el-table-column prop="name2" label="应到人数">
                    </el-table-column>

                    <el-table-column prop="name3" label="实到人数">
                    </el-table-column>

                    <el-table-column prop="name4" label="缺勤人数">
                    </el-table-column>

                    <el-table-column prop="name5" label="事假人数">
                    </el-table-column>

                    <el-table-column prop="name6" label="病假人数">
                    </el-table-column>
                    <el-table-column prop="name7" label="到校生身体状况	">
                    </el-table-column>
                    <el-table-column prop="name8" label="班级登记状态">
                    </el-table-column>

                    <el-table-column  label="操作">
                        <template slot-scope="scope">
                            <el-button  type="primary" plain  size="mini"   icon="el-icon-notebook-2" @click="openDetails(scope.row.id)">
                                查看详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="inside_pages_right_content_bottom" v-if="responseData.total > 0">
               <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="responseData.pageNum"
                    :page-sizes="[20, 30, 50, 100]"
                    :page-size="20"
                    layout="total, sizes, prev, pager, next, jumper"
                    prev-text="上一页"
                    next-text="下一页"
                    :total="responseData.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'',
    components: {},
    props: {},
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                    picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                    }
                }]
            },
            // 请求参数
            requestData :{
                schoolId : this.$store.state.schoolId,
                pageNum : 1,
                pageSize : 20,
                classId:null,
                date:null,
                status1:null,
                status2:null,
                name:null,

            },
            // 数据列表
            responseData: {
                pageNum:1,        // 第几页
                pageSize:20,      // 一页多少个
                total:0,      // 总条数
                pages:0,     // 总页数
                list:[
                    {
                        id:1,
                        name1: '二年级(六班)',
                        name2: 40,
                        name3: 40,
                        name4: 0,
                        name5: 0,
                        name6: 0,
                        name7: '优',
                        name8: '良',
                    }
                ],
            },

            classList:[],

        };
    },
    watch: {},
    computed: {},
    methods: {
        openDetails(id){
            // console.log(id)
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
         // 获取班级列表
        async getClassList(){
			var newParamData = {
                schoolId:this.$store.state.schoolId
            }
			let res = await  this.$Http.getAllClassList(newParamData,true)
			if(res.code == 200){
                if(res.data){
                    this.classList = res.data
                }
            }else if(res.code == 101){

            } else {
                this.$message({
                    type: 'error',
                    message: res.messsage
                });
            }
        },

    },
    created() {},
    mounted() {
        this.getClassList()
    }
};
</script>
